import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueApexCharts from 'vue-apexcharts'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import 'vue-search-select/dist/VueSearchSelect.css'
import 'leaflet/dist/leaflet.css'
import Vuelidate from 'vuelidate'
import "core-js/stable";
import "regenerator-runtime/runtime";
import GAuth from 'vue-google-oauth2'
import loader from "vue-ui-preloader";


const gauthOption = {
  clientId: '1032235903568-jne3c5lnc58kamaadq5pvmbuqvfno2um.apps.googleusercontent.com',
  scope: 'profile email',
  prompt: 'select_account',
  fetch_basic_profile: true
}
Vue.use(GAuth, gauthOption)
Vue.use(loader);
Vue.use(CoreuiVue)
Vue.use(Vuelidate)
Vue.use(VueApexCharts)

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.component('apexchart', VueApexCharts)

Vue.config.performance = true

Vue.prototype.$log = console.log.bind(console)
library.add(fas)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  }
})